import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Like",
  "use": "Like-usage",
  "viewBox": "0 0 33 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 36\" id=\"Like\"><path fill-rule=\"evenodd\" d=\"M.5 35.911V9.971H5v25.94H.5zM15.665.253C16.002.109 16.721 0 17.52 0c1.519 0 3.324.393 3.324 1.678v9.5H32.98s.147 8.422-.358 10.68c-.932 4.17-4.342 13.903-8.59 14.053-1.882.067-4.414.089-6.955.089-5.079 0-10.189-.089-10.189-.089V9.972s5.527-8.323 8.777-9.72zm.361 4.606v-.111A54.827 54.827 0 0 0 11 10.27v20.878c1.912.016 4.12.029 6.313.029 3.074 0 5.566-.025 7.421-.074 1.544-1.23 2.8-6.22 3.97-10.915.159-.686.258-2.537.296-5.096H16.026V4.859z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol